import { IEvent } from "@common/redux/types/event";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { EventCard } from "../../Home/Events/EventCard/EventCard";

type TProps = {
  pushkinPage?: boolean;
  events: IEvent[];
}

export function EventsGrid({ pushkinPage = false, events }: TProps) {
  return (
    <EntitiesGrid
      <IEvent>
      entityType="events"
      items={events.slice(0, 8)}
      total={8}
      offset={8}
      renderGridCard={(item: IEvent) => <EventCard key={item._id} event={item} type="small" theme="white"/>}
      pushkinPage={pushkinPage}
    />
  );
}
